import React from "react";
import PropTypes from "prop-types";

function VerificationRequired({ email }) {
  return (
    <div className="alert alert-info" role="status">
      <p>Jeśli możemy obsłużyć konto dla tego adresu, wysłaliśmy wiadomość z dalszymi instrukcjami na adres {email}.</p>
    </div>
  );
}

VerificationRequired.propTypes = {
  email: PropTypes.string.isRequired,
};

export default VerificationRequired;
